<template>
  <div>
    <a-modal
        title="融资申请"
        :visible="visible"
        :confirmLoading="confirmLoading"
        width="800px"
        :closable="false"
    >
      <a-steps :current="current">
        <a-step v-for="(item,index) in stepList"
                :key="item.title"
                :status="item.status"
                :title="item.title">
          <a-icon slot="icon" :type="item.iconType"/>
        </a-step>
      </a-steps>
      <a-form :form="formDirectional" layout="vertical">
        <a-row :gutter="16" v-show="current === 0">
          <a-col :span="12">
            <a-form-item label="主体名称">
              <a-input
                  v-decorator="['companyName']"
                  disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="统一社会信用代码">
              <a-input
                  v-decorator="['socialCreditUnicode']"
                  disabled
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="current === 0">
          <a-col :span="12" v-if="this.$store.state.account.roleType==7">
            <a-form-item label="法人代表">
              <a-input
                  v-decorator="['frdb']"
                  disabled
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="所属行业">
              <a-select
                  placeholder="请选择您的所属行业"
                  v-decorator="[
                                        'industry',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择您的所属行业'
                                                }
                                            ]
                                        }
                                    ]"
              >
                <a-select-option v-for="(item,index) in industryList" :key="item.id"
                                 :value="item.param">
                  {{item.desc}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row >
        <a-row :gutter="16" v-show="current === 0">
          <a-col :span="12">
            <a-form-item :label="this.$store.state.account.roleType==7?'经营地址':'联系地址'">
              <a-input
                  v-decorator="[
                                        'address',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写地址'
                                                }
                                            ]
                                        }
                                    ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="主体所在省市区">
              <a-cascader
                  v-decorator="['area', {
                                            rules:[
                                                {
                                                    required: true,
                                                    message:'请选择主体所在区域'
                                                },
                                            ]
                                        }]"
                  :options="changshaRegion"
                  placeholder="请选择主体所在区域"/>
              <a-input
                  v-decorator="['companyId', {}]"
                  hidden
              />
              <a-input
                  v-decorator="['frdb', {}]"
                  hidden
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="current === 0">

          <a-col :span="12">
            <a-form-item label="经办人">
              <!--              <a-input
                                v-decorator="[
                                                      'contact',
                                                      {
                                                          rules: [
                                                              {
                                                                  required: true,
                                                                  message: '请填写经办人'
                                                              }
                                                          ]
                                                      }
                                                  ]"
                            />-->
              <a-select @change="managerNameChange"
                        v-decorator="[
                                        'contact',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择经办人'
                                                }
                                            ]
                                        }
                                    ]"
                        placeholder="请选择经办人"
                        :dropdownMatchSelectWidth="false"
              >
                <a-select-option
                    :key="manager.id"
                    v-for="manager in this.contactList"
                    :values="manager.managerName"
                >
                  {{ manager.managerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="经办人身份证号码">
              <a-input
                  disabled
                  v-decorator="[
                                        'contactIdcard',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写经办人身份证号码'
                                                }
                                            ]
                                        }
                                    ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="经办人手机号码">
              <a-input
                  disabled
                  v-decorator="[
                                        'contactMobile',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写经办人手机号码'
                                                },
                                                { validator: validatePhone }
                                            ]
                                        }
                                    ]"
                  style="width:160px;margin-right: 5px"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否首贷户">
              <a-select
                  placeholder="请选择是否首贷户"
                  v-decorator="[
                                          'isFirstUser',
                                          {
                                              rules: [
                                                  {
                                                      required: true,
                                                      message: '请选择是否首贷户'
                                                  }
                                              ]
                                          }
                                      ]"
              >
                <a-select-option :value="0">
                  是
                </a-select-option>
                <a-select-option :value="1">
                  否
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16" v-show="current === 1">
          <a-col :span="12">
            <a-form-item label="所属金融机构">
              <template>
                <a-input
                    disabled
                    v-decorator="['logindept']"
                />
              </template>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="对应的金融产品">
              <a-input
                  disabled
                  v-decorator="['proname']"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="机构名称（请根据区域选择）">
              <template>
                <a-select
                    v-decorator="[
                                        'userId',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请选择机构名称'
                                                }
                                            ]
                                        }
                                    ]"
                    placeholder="请选择机构名称"
                    :dropdownMatchSelectWidth="false"
                >
                  <a-select-option
                      :key="org.id"
                      v-for="org in regionMark"
                      :value="org.id"
                  >
                    {{ org.dept }}({{ org.address }})
                  </a-select-option>
                </a-select>
              </template>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
                label="贷款金额(单位：万元，币种：人民币）"
            >
              <a-input
                  :initialValue="0"
                  v-decorator="[
                                        'commitAmout',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写贷款金额（元）'
                                                },
                                            ]
                                        }
                                    ]"
                  style="text-align: right"
                  @input="transform($event)"
              />
              <span v-if="chinesePriceVisable">{{
                  chinesePrice
                }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="current === 1">
          <a-col :span="12">
            <a-form-item label="贷款期限（月）">
              <a-input-number
                  v-decorator="[
                                        'deadline',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写贷款期限'
                                                },
                                                { validator: validateData }
                                            ]
                                        }
                                    ]"
                  style="width: 200px; margin-right: 10px"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="期望贷款到账时间">
              <a-input
                  v-decorator="[
                                        'loanArrival',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请填写您期望贷款到账时间'
                                                },
                                                { validator: validateData }
                                            ]
                                        }
                                    ]"
                  suffix="天"
                  style="width: 100%"
                  placeholder="请填写您期望贷款到账时间"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="current === 1">
          <a-col :span="12">
            <a-form-item label="贷款用途">
              <a-select
                  v-decorator="[
                                        'yt',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择贷款用途'
                                                }
                                            ]
                                        }
                                    ]"
                  placeholder="请选择贷款用途"
                  :dropdownMatchSelectWidth="false"
              >
                <a-select-option value="经营贷款">经营贷款</a-select-option>
                <a-select-option value="进货备货">进货备货</a-select-option>
                <a-select-option value="投资新店">投资新店</a-select-option>
                <a-select-option value="建设厂房">建设厂房</a-select-option>
                <a-select-option value="生产经营">生产经营</a-select-option>
                <a-select-option value="其他">其他</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="current === 2">
          <a-col :span="12">
            <a-form-item label="上年度纳税金额">
              <a-select
                  v-decorator="[
                                        'taxAmountOfLastYear',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择上年度纳税金额'
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请选择上年度纳税金额"
              >
                <a-select-option v-for="item in taxList"
                                 :key="item"
                >
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="企业盈亏状况">
              <a-select
                  v-decorator="[
                                        'profitOrLossStatus',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择企业盈亏状况'
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请选择企业盈亏状况"
              >
                <a-select-option value="亏损">
                  亏损
                </a-select-option>
                <a-select-option value="盈利">
                  盈利
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="上年度开票营业收入">
              <a-select
                  v-decorator="[
                                        'businessIncome',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择上年度开票营业收入'
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请选择上年度开票营业收入"
              >
                <a-select-option v-for="item in businessIncomeList"
                                 :key="item"
                >
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="纳税等级">
              <a-select
                  v-decorator="[
                                        'taxGrade',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择纳税等级'
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请选择纳税等级"
              >
                <a-select-option v-for="item in taxGradeList"
                                 :key="item"
                >
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否有抵押物">
              <a-select
                  v-decorator="[
                                        'isCollateral',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择是否有抵押物'
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请选择是否有抵押物"
              >
                <a-select-option value="无">
                  无
                </a-select-option>
                <a-select-option value="有">
                  有
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开户行">
              <a-input
                  v-decorator="[
                                        'bankOfDeposit',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请填写您的开户行'
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请填写您的开户行"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="当前贷款余额">
              <a-input
                  :initialValue="0"
                  v-decorator="[
                                        'currentLoanBalance',
                                        {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ]
                                        }
                                    ]"
                  suffix="万元"
                  @input="transform2($event)"
                  placeholder="请填写您当前贷款余额"
              />
              <span v-if="chinesePriceVisable2">{{
                  chinesePrice2
                }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="之前贷款机构">
              <a-input
                  v-decorator="[
                                        'previousLendingInstitutions',
                                        {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ]
                                        }
                                    ]"
                  style="width: 100%"
                  placeholder="请填写您之前贷款机构"
              >
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="current === 2">
          <a-col :span="12">
            <a-form-item>
              <a-checkbox
                  v-model="toggle"
                  v-bind:true-value="a"
                  v-bind:false-value="b"
              >
                <span style="color: #f5222d">*</span><span>同意用信单位查看信用报告</span>
              </a-checkbox>
              <a @click="down2">查看授权同意书</a>
            </a-form-item>
          </a-col>
        </a-row >

      </a-form>
      <template slot="footer">
        <div
            :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right'
                    }"
        >
          <a-button ghost v-if="current > 0" type="primary" style="margin-left: 8px;float: left"
                    @click="previousStep">
            上一步
          </a-button>
          <a-button @click="handleCancel">取消</a-button>
          <a-button
              v-if="current == stepList.length - 1"
              :loading="subbtnLoading"
              type="primary" @click="handleOk"
          >
            发布融资需求
          </a-button>
          <a-button v-if="current < stepList.length - 1" type="primary" @click="nextStep">
            下一步
          </a-button>
        </div>
      </template>

    </a-modal>


    <div>
      <a-modal
          v-model="modelState" :closable="true" footer=""
          width="1000px" @cancel="afterClose"
      >
        <div style="display: flex; flex-direction: column; text-align: left;margin-bottom: 60px;">
          <div id="title" style="margin-bottom: 5px;">
            <h1 style="text-align: center;margin: 0px auto">
              <p style="font-size: 24px;display: inline-block;">
                {{titleName}}
              </p>
            </h1>
          </div>
          <div style="width: 800px;margin-left: auto;margin-right: auto;">
            <p>
              <span v-html="editContent"></span>
            </p>
          </div>
        </div>
      </a-modal>
    </div>
    <a-modal
        v-model="showOperatorCode"
        :closable="true"
        width="400px"
        @cancel="handleCancel"
        title="短信验证"
    >
      <template #footer>
        <div >
          <a-space>
            <a-button @click="handleCancel">取消</a-button>
            <a-button @click="handleOk" type="primary">提交</a-button>
          </a-space>
        </div>
      </template>
      <div
          style="
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    margin-bottom: 60px;
                "
      >
        <p style="line-height: 30px">请输入手机验证码:</p>
        <a-input v-model:value="operatorCode" placeholder="请输入手机验证码" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import {addFinancing, getFzjg, mySelect, priceToChinese, uoloadFilesq, numberToChines,financingRequirementsCode} from "../../api/http";
import {getEnablePowerOfAttorney} from "@/api/powerOfAttorne/powerOfAttorne";
import {sendcode} from "@/api/user";
import {getSqtys} from "@/api/finance/finance";
import {getManagerLists} from "@/api/manager/manager";
import {mapGetters, mapState} from "vuex";
import {getTypes,findOnProId} from '@/api/finance/finance'
import changshaRegion from "@/assets/changshaRegion";

export default {
  name: "directional",
  computed: {
    ...mapState(["downPath"]),
    ...mapGetters(["storeAccount"])
  },

  data() {
    const stepList = [
      {
        title: '基础信息',
        status: 'finish',
        iconType: 'user'
      },
      {
        title: '融资期望',
        status: 'wait',
        iconType: 'money-collect'
      },
      {
        title: '企业信息',
        status: 'wait',
        iconType: 'team'
      },
    ];
    return {
      stepList,
      current: 0,
      changshaRegion,
      visible: false,
      confirmLoading: false,
      chinesePriceVisable: false,
      subbtnLoading:false,
      loading: false,
      formDirectional: this.$form.createForm(this),
      proid: "",
      titleName: "",
      editContent: "",
      regionMark: [],
      contactList: [],
      modelState: false,
      authorization: "",
      chinesePrice: "",
      imageUrl: "",
      uploadImgUrl: "",
      a: "a",
      b: "b",
      toggle: false,
      disabled:false,
      buttontext:"发送验证码",
      wait:60,
      taxList: [
        "0-2万（含）",
        "2-5万（含）",
        "5-10万（含）",
        "10万以上",
      ],
      businessIncomeList: [
        "0-100万（含）",
        "100-500万（含）",
        "500-1000万（含）",
        "1000万以上",
      ],
      taxGradeList: [
        "A",
        "B",
        "C",
        "D",
        "M",
        "个体工商户",
      ],
      industryList: [],
      financingRequirementsCode:"",
      operatorCode:"",
      showOperatorCode:false
    }
  },
  created() {
    this.getIndustry();
    this.changshaRegion.map(item => {
      item.label = item.name
      item.value = item.name
      item.children.map(res => {
        res.label = res.name;
        res.value = res.name;
        res.children.map(resp => {
          resp.label = resp.name;
          resp.value = resp.name;
        })
      })
    })
  },
  methods: {
    //下一步
    nextStep() {
      let validateFields =
          this.current === 0 ? ["companyName", "area", "contact", "contactMobile", "industry", "isFirstUser"] :
              this.current === 1 ? ["commitAmout", "interestRate", "deadline", "loanArrival", "userId","yt"] :
                  this.current === 2 ? ["taxAmountOfLastYear", "profitOrLossStatus", "businessIncome", "taxGrade", "isCollateral", "bankOfDeposit", "currentLoanBalance", "previousLendingInstitutions"] : [];
      this.formDirectional.validateFields(validateFields, (err, value) => {
        if (!err) {
          let bool = null;
          if (this.current === 1) {
            let accountId = this.$store.state.account.name;
            findOnProId(accountId, this.proid)
                .then(res => {
                  bool = res.data.data.result;
                  if (!bool) {
                    this.$message.warn("该产品存在进行中的订单，请勿重复申请！");
                  } else {
                    this.current++;
                    this.stepList[this.current].status = "finish";
                  }
                })
          } else {
            this.current++;
            this.stepList[this.current].status = "finish";
          }
        }
      })
    },
    //上一步
    previousStep() {
      this.stepList[this.current].status = "wait";
      this.current--;
    },
    getIndustry() {
      getTypes("003008")
          .then(res => {
            if (res.data.success == "TRUE") {
              this.industryList = res.data.data.list;
            }
          }).catch(() => {
        this.$message.error("服务器出错！请稍后再试!");
      });
    },
    afterClose() {
      this.editContent = "";
      this.titleName = "";
      this.modelState2 = false;
    },
    //选择经办人触发
    managerNameChange(value) {
      for (let i = 0; i < this.contactList.length; i++) {
        if (this.contactList[i]['id'] == value) {
          this.formDirectional.setFieldsValue({
            contact: this.contactList[i]['managerName'],
            contactIdcard: this.contactList[i]['identificationNumber'],
            contactMobile: this.contactList[i]['phone']
          })
        }
      }
    },
    oninputComout(el) {
      // console.log(el)
    },

    transform(el) {
      //设置只能输入5位整数和2位小数
      let reg = /^\d{1,5}(\.\d{1,2})?$/;
      let val = el.target.value.replace(",", "");
      let target = el.target;
      target.oninput = () => {
        target.value = target.value.replace(",", "");
        //清除非 数字和小数点的字符
        target.value = target.value.replace(/[^\d.]/g, "")
        //清除第二个小数点
        target.value = target.value.replace(/\.{2,}/g, ".")
        //验证第一个字符是数字而不是字符
        target.value = target.value.replace(/^\./g, "");
        target.value = target.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        //保留两位小数
        target.value = target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        //限制只能输入5位正整数
        target.value = target.value.indexOf(".") > 0 ? target.value.split(".")[0].substring(0, 5) + "." + target.value.split(".")[1] : target.value.substring(0, 5);
      }
      if (reg.test(val)) {
        let Dnum = val;
        // let Dnum = this.formDirectional.getFieldsValue().commitAmout;
        if (Dnum == "") {
          this.chinesePriceVisable = false;
          return;
        }
        let intNum = Dnum.toString().replace(/,/g, "").split(".");
        let strIntNum = intNum[0];
        let strDecNum = intNum[1];
        let count = 0;
        let result = [];
        for (let i = strIntNum.length - 1; i >= 0; i--) {
          count++;
          result.unshift(strIntNum[i]);
          if (!(count % 3) && i != 0) {
            result.unshift(",");
          }
        }
        result = result.join("");
        if (intNum.length > 1) {
          strDecNum = intNum[1];
          result = result + "." + strDecNum;
        }

        this.formDirectional.setFieldsValue({
          commitAmout: result
        });

        // this.chinesePrice = priceToChinese(Dnum);
        this.chinesePrice = numberToChines(Dnum);
        this.chinesePriceVisable = true;
      }
    },
    //我要融资（定向）
    financingDirectional(productInfo) {
      this.visible = true;
      this.chinesePrice = "";
      this.proid=productInfo.id;
      mySelect().then(res => {
        if (res.data.success === "TRUE") {
          this.formDirectional.setFieldsValue({
            companyName: res.data.data.qyname,
            socialCreditUnicode: res.data.data.uscc,
            companyId: res.data.data.companyId,
            frdb: res.data.data.frdb,
            address:res.data.data.address,
            logindept: productInfo.logindept,
            proname:productInfo.proname
          });
          getManagerLists().then(resp => {
            this.contactList = resp.data.data.list;
            this.formDirectional.setFieldsValue({
              contactIdcard: this.contactList[0]['identificationNumber'],
              contact: this.contactList[0]['managerName'],
              contactMobile: this.contactList[0]['phone'].toString(),
            })
          })
        }
      });
      this.getFzjg(productInfo.logindeptid,productInfo.regionId)
    },
    getFzjg(yxdwId, area){
      getFzjg(yxdwId, area).then(res =>{
        if (res.data.success === "TRUE") {
          this.regionMark = res.data.data.fzjg;
          this.regionMark.forEach(it =>{
            if(it.area.indexOf(this.storeAccount.area)>-1){
              this.formDirectional.setFieldsValue({
                userId: it.id
              });
            }
          })
        }
      })
    },
    //上传按钮
    handleChange(info) {
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} 上传成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    beforeUpload(file) {
      const isJPG =
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/gif";
      if (!isJPG) {
        this.$message.error("你只能上传图片!");
        return false;
      }
      const isLt300k = file.size / 1024;
      if (isLt300k > 300) {
        this.$message.error("图片只能小于300k!");
        return false;
      }
      return isJPG && isLt300k;
    },
    customRequest(files) {
      this.text = files.text;
      let formData = new FormData();
      formData.append("file", files.file);

      uoloadFilesq(formData)
          .then((res) => {
            if (res.data.success === "TRUE") {
              this.uploadImgUrl = res.data.data.sqtys;
              this.$message.success("图片上传成功!");
              this.imageUrl = this.uploadImgUrl;
              this.loading = false;
            }
          })
          .catch(() => {
            this.$message.error("上传错误，请重新上传");
          });
    },
    validatePhone(rule, value, callback) {
      let reg = /^1[3456789]\d{9}$/;
      if (value && !reg.test(value)) {
        callback("请填写正确的手机号码");
      } else {
        callback();
      }
    },
    validateData(rule, value, callback) {
      let reg = /^\d+(\.\d+)?$/;
      if (value && !reg.test(value)) {
        callback("请填写数字");
      } else {
        callback();
      }
    },
    down(){
      let aTag = document.createElement('a');
      aTag.download = "授权书模板.doc";
      aTag.href = this.$store.state.downPath2;
      aTag.click();
    },
    sendcode(type){
      let userName=null
      if(type==1){
        userName=this.formDirectional.getFieldValue("contactMobile");
      }else{
        userName=this.formSnatch.getFieldValue("contactMobile");
      }
      if(userName){
        sendcode(userName)
            .then(res => {
              this.$ajaxAfter(res).then(() => {
                this.time();
              });
            })
            .catch(() => {
              this.$message.error("服务器出错！请稍后再试!");
            });
      }else{
        this.$message.error("请输入经办人手机号!");
      }
    },
    time() {
      if (this.wait == 0) {
        this.disabled=false;
        this.buttontext="获取验证码";
        this.wait = 60;
      } else {
        this.disabled=true;
        this.buttontext="重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(() => {
          this.time()
        },1000)
      }
    },
    handleOk() {
      this.formDirectional.validateFields((err, values) => {
        // console.log(values);
        if (!err) {
          values.status = 0;
          values.proid = this.proid;
          values.sqtys = this.uploadImgUrl;
          values.commitAmout = values.commitAmout.toString().replace(/,/g, "");
          if (this.toggle) {
            values.agree = 1;
            this.subbtnLoading = true;
            if (this.financingRequirementsCode == "") {
              financingRequirementsCode(values).then((res) => {
                if (res.data.success) {
                  this.financingRequirementsCode = res.data.financingRequirementsCode;
                  this.title = this.title+"，省统一需求编码："+this.financingRequirementsCode;
                  if(res.data.isCheck==1){
                    this.showOperatorCode=true;
                    this.subbtnLoading = false;
                    return false;
                  }else{
                    values.financingRequirementsCode = this.financingRequirementsCode;
                    values.operatorCode=this.operatorCode;
                    this.dosave(values);
                  }
                }else {
                  this.subbtnLoading = false;
                }
              }).catch(() => {
                this.subbtnLoading = false;
                this.$message.error("获取统一需求编码失败，请重试");
              });
            }else{
              values.financingRequirementsCode = this.financingRequirementsCode;
              values.operatorCode=this.operatorCode;
              this.dosave(values);
            }
          } else {
            this.$message.error("请选择同意用信单位查看信用报告");
          }
        }
      });
    },
    dosave(values) {
      addFinancing(values)
          .then((res) => {
            this.subbtnLoading = false;
            if (res.data.success === "TRUE") {
              this.handleCancel();
              this.$message.success("融资提交成功");
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(() => {
            this.$message.error("融资提交失败，请重试");
          });
    },
    down2() {

      this.modelState = true;
      getEnablePowerOfAttorney().then(resp => {
        this.titleName = resp.data.data.result.title;
        this.editContent = resp.data.data.result.content;
      })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
      // getSqtys()
      //     .then(res => {
      //       this.authorization=res.data.data.authorization;
      //       this.modelState=true;
      //     })
      //     .catch(() => {
      //       this.$message.error("服务器出错！请稍后再试!");
      //     });
    },
    handleCancel() {
      this.visible = false;
      this.formDirectional.resetFields();
      this.regionMark=[];
      this.uploadImgUrl = "";
      this.imageUrl = "";
      this.current = 0;
      this.stepList[1].status = "wait";
      this.stepList[2].status = "wait";
      this.financingRequirementsCode="";
      this.operatorCode="";
      this.showOperatorCode = false;
    },
  }
}
</script>

<style scoped>

</style>
